export default __webpack_public_path__ + "static/media/alexander-gibson-resume-2022-image.dd987c79.png";